import React, { useEffect } from 'react';
import {
  VIEW_PROPOSAL_TW,
  SEARCH_CUSTOMER_BY_NUMBER,
  LOB_PRODUCT_LIST,
  TWO_WHEELER_BUSINESS_TYPE,
  APPLICABLE_COVERS,
  PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS,
  FINANCER_DROPDOWN_DETAILS,
  INTERMEDIARY_LIST,
  LOOKUP_FIELDUSER,
} from './queries';
import { useQuery } from '@apollo/client';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import { useFetchQuery } from 'quanta-flows';
import { Loading, Error } from 'quanta-flows/modules/layout';
import { ClientService ,Layout} from 'quanta-flows/modules/layout';
import { Card, useResponsiveParams, Text } from 'quanta-ui';
import NewMotorPolicyIssuance from '../new-policy-issuance/motor/MISCD';

export default function ViewProposalDetailsMISCD({
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  proposalNumber,
}) {
  const fetchQuery = useFetchQuery();

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const { loading, error, data } = useQuery(VIEW_PROPOSAL_TW, {
    variables: {
      input: {
        productCode,
        proposalNumber,
        customerID,
      },
    },
  });

  const {
    loading: loadingCustomerDetails,
    error: errorCustomerDetails,
    data: dataCustomerDetails,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
      customer_type: 'Individual',
      customer_number: customerID,
      },
    },
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);

  useEffect(() => {
    const fetchViewProposalData = async () => {
      if (data && dataCustomerDetails && dataMyIntermediaries) {
        try {
          if (
            customerID?.toString()?.trim()?.toLowerCase() ===
            data?.viewProposalTW?.customerID
              ?.toString()
              ?.trim()
              ?.toLowerCase()
          ) {
            const customer = dataCustomerDetails?.customer;

            const getTwoWheelerBusinessTypeQuery = fetchQuery({
              query: TWO_WHEELER_BUSINESS_TYPE,
              variables: {
                filter: {
                productCode: productCode,
                productType: data?.viewProposalTW?.productType,
                },
              },
            });
            const getLobProductList = fetchQuery({
              query: LOB_PRODUCT_LIST,
            });
            const getApplicableCovers = fetchQuery({
              query: APPLICABLE_COVERS,
              variables: {
                input: {
                  productCode,
                  productType: data?.viewProposalTW?.productType,
                  intermediaryCode:
                    data?.viewProposalTW?.intermediaryDetails?.code,
                  fuelType:
                    data?.viewProposalTW?.vehicleDetails?.fuelType,
                },
              },
            });
            const getPolicyTermTypePreviousPolicy = fetchQuery({
              query: PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS,
              variables: {
                productCode,
              },
            });
            const getFinancerDropdownDetailsQuery = fetchQuery({
              query: FINANCER_DROPDOWN_DETAILS,
              variables: {
                productCode:3137,
              },
            });
            let { data: twoWheelerBusinessTypeData } =
              await getTwoWheelerBusinessTypeQuery;
            let { data: getLobListData } = await getLobProductList;
            let { data: getApplicableCoversData } =
              await getApplicableCovers;
            let { data: getPolicyTermTypePreviousPolicyData } =
              await getPolicyTermTypePreviousPolicy;
            let { data: getFinancerDropdownDetailsData } =
              await getFinancerDropdownDetailsQuery;
            if (
              data?.viewProposalTW?.intermediaryDetails?.fieldUserCode
            ) {
              var associatedEntityLookupQuery = fetchQuery({
                query: LOOKUP_FIELDUSER,
                variables: {
                  filter: {
                  fieldUserID: data?.viewProposalTW
                    ?.intermediaryDetails?.fieldUserCode
                    ? `${data?.viewProposalTW?.intermediaryDetails?.fieldUserCode}`
                    : '',
                  },
                },
              });
              var { data: associatedEntityLookupData } =
                await associatedEntityLookupQuery;
            }

            const { getTwoWheelerBusinessType } =
              twoWheelerBusinessTypeData;
            const { lobProductList } = getLobListData;
            const { applicableCovers } = getApplicableCoversData;
            const {
              PRD_PreviousPolicyTermList,
              PRD_TotalClaimCountList,
            } = getPolicyTermTypePreviousPolicyData;
            const associatedEntityLookup =
              associatedEntityLookupData?.associatedEntityLookup;

            const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
              getFinancerDropdownDetailsData;

            let addOnCovers = {};
            const { myIntermediaries } = dataMyIntermediaries;

            data?.viewProposalTW?.riskCovers?.forEach((riskCover) => {
              riskCover?.covers
                ?.filter((cover) =>
                  applicableCovers?.riskCovers
                    ?.find(
                      (rC) =>
                        rC?.riskType?.toString()?.toLowerCase() ===
                        riskCover?.riskType
                          ?.toString()
                          ?.toLowerCase(),
                    )
                    ?.covers?.find(
                      (c) =>
                        c?.name?.toString()?.toLowerCase() ===
                          cover?.name?.toString()?.toLowerCase() &&
                        c?.index?.toString()?.toLowerCase() ===
                          cover?.index?.toString()?.toLowerCase(),
                    ),
                )
                ?.forEach((cover) => {
                  addOnCovers[`${cover?.name}`] = {
                    selected: cover?.selected ? true : false,
                    attributes: {},
                  };
                  cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    .forEach((attribute) => {
                      addOnCovers[`${cover?.name}`][`attributes`][
                        `${attribute?.name}`
                      ] =
                        data?.viewProposalTW?.riskCovers
                          ?.find(
                            (rc) =>
                              rc?.riskType
                                ?.toString()
                                ?.toLowerCase() ===
                              riskCover?.riskType
                                ?.toString()
                                ?.toLowerCase(),
                          )
                          ?.covers?.find(
                            (c) =>
                              c?.name?.toString()?.toLowerCase() ===
                              cover?.name?.toString()?.toLowerCase(),
                          )
                          ?.attributes?.find(
                            (a) =>
                              a?.name?.toString()?.toLowerCase() ===
                              attribute?.name
                                ?.toString()
                                ?.toLowerCase(),
                          )?.dataValues?.length > 0
                          ? data?.viewProposalTW?.riskCovers
                              ?.find(
                                (rc) =>
                                  rc?.riskType
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  riskCover?.riskType
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                              ?.covers?.find(
                                (c) =>
                                  c?.name
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  cover?.name
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                              ?.attributes?.find(
                                (a) =>
                                  a?.name
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  attribute?.name
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                              ?.dataValues?.find(
                                (dataValue) =>
                                  dataValue?.code
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  attribute?.value
                                    ?.toString()
                                    ?.toLowerCase(),
                              )
                            ? attribute?.value
                            : ''
                          : attribute?.value
                          ? attribute?.value
                          : attribute?.defaultValue
                          ? attribute?.defaultValue
                          : '';
                    });
                });
            });

            const getIntermediaryName = (code) => {
              return myIntermediaries
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode === code,
                  )?.intermediaryName
                : code;
            };

            const getBusinessLocation = (
              intermediarycode,
              locationCode,
            ) => {
              return myIntermediaries &&
                intermediarycode &&
                locationCode
                ? myIntermediaries?.find(
                    (intermediary) =>
                      intermediary?.intermediaryCode ===
                      intermediarycode,
                  )
                  ? myIntermediaries
                      ?.find(
                        (intermediary) =>
                          intermediary?.intermediaryCode ===
                          intermediarycode,
                      )
                      ?.businessLocations.find(
                        (location) => location?.code === locationCode,
                      )?.name
                  : locationCode
                : '';
            };

            updateBuyMotorPolicy({
              businessType: data?.viewProposalTW?.businessType
                ? `${data?.viewProposalTW?.businessType}`
                : '',
              intermediaryDetails: {
                code: data?.viewProposalTW?.intermediaryDetails?.code,
                intermediaryName: getIntermediaryName(
                  data?.viewProposalTW?.intermediaryDetails?.code,
                ),
                location:
                  data?.viewProposalTW?.intermediaryDetails?.location,
                branchOfficeName: getBusinessLocation(
                  data?.viewProposalTW?.intermediaryDetails?.code,
                  data?.viewProposalTW?.intermediaryDetails?.location,
                ),
                fieldUserCode:
                  data?.viewProposalTW?.intermediaryDetails
                    ?.fieldUserCode,
                fieldUserName: associatedEntityLookup?.fieldUserName
                  ? `${associatedEntityLookup?.fieldUserName}`
                  : '',
              },
              businessTypeValue:
                getTwoWheelerBusinessType?.code?.toLowerCase() ===
                data?.viewProposalTW?.businessType?.toLowerCase()
                  ? getTwoWheelerBusinessType?.value
                  : '',
              customerFetchRequiredOnLoad: false,
              productType: data?.viewProposalTW?.productType
                ? `${data?.viewProposalTW?.productType}`
                : '',
              productVariant:data?.viewProposalTW?.productType
              ? `${data?.viewProposalTW?.productType}`
              : '',
              productTypeValue:
                lobProductList && lobProductList?.length > 0
                  ? lobProductList
                      ?.find(
                        (lob) =>
                          lob?.lob_name?.toLowerCase() ===
                          lobName?.toLowerCase(),
                      )
                      ?.products?.find(
                        (product) =>
                          product?.product_types?.find(
                            (pType) =>
                              pType?.code?.toLowerCase() ===
                              data?.viewProposalTW?.productType?.toLowerCase(),
                          ) !== undefined,
                      )
                      ?.product_types?.find(
                        (pType) =>
                          pType?.code?.toLowerCase() ===
                          data?.viewProposalTW?.productType?.toLowerCase(),
                      )?.value
                  : '',
              isQuoteSaved: true,
              nomineeDetails:
              {name:data?.viewProposalTW?.nomineeDetails?.name,
                relationship: data?.viewProposalTW?.nomineeDetails?.relationship,
                dob: data?.viewProposalTW?.nomineeDetails?.dob,
                 relationshipWithAppointee: data?.viewProposalTW?.nomineeDetails?.relationshipWithAppointee,
                 nameOfAppointee: data?.viewProposalTW?.nomineeDetails?.nameOfAppointee,
              },
              quoteData: {
                get_covers: true,
                quotationNo: data?.viewProposalTW?.quoteNumber
                  ? `${data?.viewProposalTW?.quoteNumber}`
                  : '',
                quotationStatus: '',
                quoteCreationDate: '',
                productType: data?.viewProposalTW?.productType
                  ? `${data?.viewProposalTW?.productType}`
                  : '',
                productVariant:data?.viewProposalTW?.productType
                  ? `${data?.viewProposalTW?.productType}`
                  : '',
                proposalNumber: data?.viewProposalTW?.proposalNumber
                  ? `${data?.viewProposalTW?.proposalNumber}`
                  : '',
                productTypeValue:
                  lobProductList && lobProductList?.length > 0
                    ? lobProductList
                        ?.find(
                          (lob) =>
                            lob?.lob_name?.toLowerCase() ===
                            lobName?.toLowerCase(),
                        )
                        ?.products?.find(
                          (product) =>
                            product?.product_types?.find(
                              (pType) =>
                                pType?.code?.toLowerCase() ===
                                data?.viewProposalTW?.productType?.toLowerCase(),
                            ) !== undefined,
                        )
                        ?.product_types?.find(
                          (pType) =>
                            pType?.code?.toLowerCase() ===
                            data?.viewProposalTW?.productType?.toLowerCase(),
                        )?.value
                    : '',
                businessType: data?.viewProposalTW?.businessType
                  ? `${data?.viewProposalTW?.businessType}`
                  : '',
                businessTypeValue:
                  getTwoWheelerBusinessType?.code?.toLowerCase() ===
                  data?.viewProposalTW?.businessType?.toLowerCase()
                    ? getTwoWheelerBusinessType?.value
                    : '',
                regNo: data?.viewProposalTW?.vehicleDetails
                  ?.registrationNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber}`
                  : '',
                isRegNoVerified: true,
                isPrevClaimsAvailable: null,
                isPrevInsuranceAvailable: null,
                isPrevInsuranceLoading: false,
                mode: '',
                vehicleRegNo: {
                  part1:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          0,
                          2,
                        )}`
                      : '',
                  part2:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          2,
                          4,
                        )}`
                      : '',
                  part3:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                        2,
                        4,
                      )?.toLowerCase() === 'bh'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                        4,
                        8,
                        )}`
                      : `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          4,
                          6,
                        )}`
                      : '',
                  part4:
                    data?.viewProposalTW?.vehicleDetails
                      ?.registrationNumber &&
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                      'new'
                      ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                        2,
                        4,
                      )?.toLowerCase() === 'bh'
                      ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                        8,
                        10,
                        )}`
                        : `${data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                          6,
                          10,
                        )}`
                      : '',
                  bhseries :  data?.viewProposalTW?.vehicleDetails?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !== 'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            2,
                            4,
                          )?.toLowerCase() === 'bh' ? true : false 
                        : false,
                },
                changedIDV: data?.viewProposalTW?.firstYearIDV
                  ? `${data?.viewProposalTW?.firstYearIDV}`
                  : '',
                adjustmentIRF: data?.viewProposalTW?.irf1
                  ? `${data?.viewProposalTW?.irf1}`
                  : '',
                anyPreviousPolicyforVehicleTaken: data?.viewProposalTW
                  ?.isPreviousPolicy
                  ? 'Yes'
                  : 'No',
                isVehicleDetailsAvailable: true,
                policyCoverType: data?.viewProposalTW
                  ?.prevInsuranceDetails?.coverType
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                  : '',
                policyTenure: data?.viewProposalTW
                  ?.prevInsuranceDetails?.policyTenure
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                  : '',
                policyTenureValue:
                  PRD_PreviousPolicyTermList &&
                  PRD_PreviousPolicyTermList?.length > 0
                    ? PRD_PreviousPolicyTermList?.find(
                        (policyTerm) =>
                          policyTerm?.code?.toLowerCase() ===
                          data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                      )?.value
                    : '',
                policyStartDate: data?.viewProposalTW
                  ?.prevInsuranceDetails?.startDate
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                  : '',
                policyExpiryDate: data?.viewProposalTW
                  ?.prevInsuranceDetails?.expiryDate
                  ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                  : '',
                totalClaimCount: data?.viewProposalTW?.previousClaims
                  ?.totalClaimCount
                  ? `${data?.viewProposalTW?.previousClaims?.totalClaimCount}`
                  : '',
                totalClaimCountValue:
                  PRD_TotalClaimCountList &&
                  PRD_TotalClaimCountList?.length > 0
                    ? PRD_TotalClaimCountList?.find(
                        (totalClaimCount) =>
                          totalClaimCount?.code?.toLowerCase() ===
                          data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                      )?.value
                    : '',
                noOfClaimsOneYear: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear1
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear1}`
                  : '',
                noOfClaimsTwoYears: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear2
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear2}`
                  : '',
                noOfClaimsThreeYears: data?.viewProposalTW
                  ?.previousClaims?.claimsInYear3
                  ? `${data?.viewProposalTW?.previousClaims?.claimsInYear3}`
                  : '',
                totalClaimAmount:
                  data?.viewProposalTW?.previousClaims
                    ?.totalClaimAmount !== null &&
                  data?.viewProposalTW?.previousClaims
                    ?.totalClaimAmount !== undefined
                    ? `${data?.viewProposalTW?.previousClaims?.totalClaimAmount}`
                    : '',
                previousYearNCBSlab: data?.viewProposalTW
                  ?.previousClaims
                  ? `${data?.viewProposalTW?.previousClaims?.prevNCBSlab}`
                  : '',
                vehicleIsOwnedBy: customer?.cust_type?.code
                  ? `${customer?.cust_type?.code}${
                      customer?.indv_detail?.gender?.code
                        ? `#${customer?.indv_detail?.gender?.code}`
                        : ''
                    }`
                  : '',
                vehicleOwnerTypeAndGender: {
                  gender: customer?.indv_detail?.gender?.code
                    ? `${customer?.indv_detail?.gender?.code}`
                    : '',
                  organisationType: customer?.cust_type?.code
                    ? `${customer?.cust_type?.code}`
                    : '',
                },
                pincode:
                  customer?.permanent_address?.pin_code ||
                  customer?.communication_address?.pin_code
                    ? `${
                        customer?.permanent_address?.pin_code ||
                        customer?.communication_address?.pin_code
                      }`
                    : '',
                state:
                  customer?.permanent_address?.state ||
                  customer?.communication_address?.state
                    ? `${
                        customer?.permanent_address?.state ||
                        customer?.communication_address?.state
                      }`
                    : '',
                city:
                  customer?.permanent_address?.city ||
                  customer?.communication_address?.city
                    ? `${
                        customer?.permanent_address?.city ||
                        customer?.communication_address?.city
                      }`
                    : '',
                district:
                  customer?.permanent_address?.district ||
                  customer?.communication_address?.district
                    ? `${
                        customer?.permanent_address?.district ||
                        customer?.communication_address?.district
                      }`
                    : '',
                getAdditionalCreditScore: data?.viewProposalTW
                  ?.creditScore?.discountOpted
                  ? 'Yes'
                  : 'No',
                idProofType:
                  data?.viewProposalTW?.creditScore?.discountOpted &&
                  data?.viewProposalTW?.creditScore?.idProofType
                    ? `${data?.viewProposalTW?.creditScore?.idProofType}`
                    : '',
                idProofNumber:
                  data?.viewProposalTW?.creditScore?.discountOpted &&
                  data?.viewProposalTW?.creditScore?.idProofNumber
                    ? `${data?.viewProposalTW?.creditScore?.idProofNumber}`
                    : '',
                voluntaryDeductibleAmount: data?.viewProposalTW
                  ?.voluntaryDeductibleAmt
                  ? `${data?.viewProposalTW?.voluntaryDeductibleAmt}`
                  : '',
             NCB: data?.viewProposalTW
                  ?.NCB
                  ? `${data?.viewProposalTW?.NCB}`
                  : '',
                make: {
                  code: data?.viewProposalTW?.vehicleDetails?.make
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.make?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.make
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.make?.value}`
                    : '',
                },
                model: {
                  code: data?.viewProposalTW?.vehicleDetails?.model
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.model?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.model
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.model?.value}`
                    : '',
                },
                variant: {
                  code: data?.viewProposalTW?.vehicleDetails?.variant
                    ?.code
                    ? `${data?.viewProposalTW?.vehicleDetails?.variant?.code}`
                    : '',
                  value: data?.viewProposalTW?.vehicleDetails?.variant
                    ?.value
                    ? `${data?.viewProposalTW?.vehicleDetails?.variant?.value}`
                    : '',
                },
                fuelType: data?.viewProposalTW?.vehicleDetails
                  ?.fuelType
                  ? `${data?.viewProposalTW?.vehicleDetails?.fuelType}`
                  : '',
                seatingCapacity: data?.viewProposalTW?.vehicleDetails
                  ?.seatingCapacity
                  ? `${data?.viewProposalTW?.vehicleDetails?.seatingCapacity}`
                  : '',
                cubeCapacity: data?.viewProposalTW?.vehicleDetails
                  ?.cubicCapacity
                  ? `${data?.viewProposalTW?.vehicleDetails?.cubicCapacity}`
                  : '',
                gvw:data?.viewProposalTW?.vehicleDetails
                ?.gvw? data?.viewProposalTW?.vehicleDetails
                ?.gvw
                :'', 
              
                yearOfManufacture: data?.viewProposalTW
                  ?.vehicleDetails?.manufactureYear
                  ? `${data?.viewProposalTW?.vehicleDetails?.manufactureYear}`
                  : '',
                dateOfReg: data?.viewProposalTW?.vehicleDetails
                  ?.regPurchaseDate
                  ? `${data?.viewProposalTW?.vehicleDetails?.regPurchaseDate}`
                  : '',
                rtoLocationCode: data?.viewProposalTW?.rtoDetails
                  ?.rtoLocCode
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoLocCode}`
                  : '',
                rtoLocationDesc: data?.viewProposalTW?.rtoDetails
                  ?.rtoLocDesc
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoLocDesc}`
                  : '',
                rtoAuthorityCode: data?.viewProposalTW?.rtoDetails
                  ?.rtoAuthCode
                  ? `${data?.viewProposalTW?.rtoDetails?.rtoAuthCode}`
                  : '',
                engineNo: data?.viewProposalTW?.vehicleDetails
                  ?.engineNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.engineNumber}`
                  : '',
                chasisNo: data?.viewProposalTW?.vehicleDetails
                  ?.chasisNumber
                  ? `${data?.viewProposalTW?.vehicleDetails?.chasisNumber}`
                  : '',
                preInspectionNumber:data?.viewProposalTW?.vehicleDetails?.preInspectionNumber
                  ?data?.viewProposalTW?.vehicleDetails?.preInspectionNumber
                  :'',
                financerName: data?.viewProposalTW?.financerDetails
                  ?.financerName
                  ? `${data?.viewProposalTW?.financerDetails?.financerName}`
                  : '',
                prevInsurance: {
                  insurerName: data?.viewProposalTW
                    ?.prevInsuranceDetails?.insurerName
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.insurerName}`
                    : '',
                  policyNumber: data?.viewProposalTW
                    ?.prevInsuranceDetails?.policyNumber
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyNumber}`
                    : '',
                  expiryDate: data?.viewProposalTW
                    ?.prevInsuranceDetails?.expiryDate
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                    : '',
                  startDate: data?.viewProposalTW
                    ?.prevInsuranceDetails?.startDate
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                    : '',
                  coverType: data?.viewProposalTW
                    ?.prevInsuranceDetails?.coverType
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                    : '',
                  policyTenure: data?.viewProposalTW
                    ?.prevInsuranceDetails?.policyTenure
                    ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                    : '',
                },
                totalIDV:data?.viewProposalTW?.totalIDV?
                 data?.viewProposalTW?.totalIDV
                :'', 
                bodyIDV:data?.viewProposalTW
                ?.bodyIDV
                ? data?.viewProposalTW
                ?.bodyIDV
                :'', 
                tenure:
                  data?.viewProposalTW?.premium?.tenure ||
                  data?.viewProposalTW?.tenure
                    ? `${
                        data?.viewProposalTW?.premium?.tenure ||
                        data?.viewProposalTW?.tenure
                      }`
                    : '',
                coverData: {
                  addOnCovers:
                    data?.viewProposalTW?.riskCovers &&
                    data?.viewProposalTW?.riskCovers?.length > 0
                      ? data?.viewProposalTW?.riskCovers
                      : [],
                  rawRiskData: applicableCovers?.riskCovers,
                },
                premiumData: {
                  idv1: data?.viewProposalTW?.premium?.idv1
                    ? `${data?.viewProposalTW?.premium?.idv1}`
                    : '',
                  idv2: data?.viewProposalTW?.premium?.idv2
                    ? `${data?.viewProposalTW?.premium?.idv2}`
                    : '',
                  idv3: data?.viewProposalTW?.premium?.idv3
                    ? `${data?.viewProposalTW?.premium?.idv3}`
                    : '',
                  tenure:
                    data?.viewProposalTW?.premium?.tenure ||
                    data?.viewProposalTW?.tenure
                      ? `${
                          data?.viewProposalTW?.premium?.tenure ||
                          data?.viewProposalTW?.tenure
                        }`
                      : '',
                  netODPremium: data?.viewProposalTW?.premium
                    ?.netODPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netODPremium,
                      )
                    : null,
                  netTPPremium: data?.viewProposalTW?.premium
                    ?.netTPPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netTPPremium,
                      )
                    : null,
                  loadingDiscount: data?.viewProposalTW?.premium
                    ?.loadingDiscount
                    ? parseFloat(
                        data?.viewProposalTW?.premium
                          ?.loadingDiscount,
                      )
                    : null,
                  netPremium: data?.viewProposalTW?.premium
                    ?.netPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.netPremium,
                      )
                    : null,
                  gst: data?.viewProposalTW?.premium?.gst
                    ? parseFloat(data?.viewProposalTW?.premium?.gst)
                    : null,
                  stampDuty: data?.viewProposalTW?.premium?.stampDuty
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.stampDuty,
                      )
                    : null,
                  totalPremium: data?.viewProposalTW?.premium
                    ?.totalPremium
                    ? parseFloat(
                        data?.viewProposalTW?.premium?.stampDuty,
                      )
                    : null,
                  loading:
                    data?.viewProposalTW?.premium?.loading &&
                    data?.viewProposalTW?.premium?.loading?.length > 0
                      ? data?.viewProposalTW?.premium?.loading
                      : [],
                  discount:
                    data?.viewProposalTW?.premium?.discount &&
                    data?.viewProposalTW?.premium?.discount?.length >
                      0
                      ? data?.viewProposalTW?.premium?.discount
                      : [],
                  vehicleAge: data?.viewProposalTW?.premium
                    ?.vehicleAge
                    ? `${data?.viewProposalTW?.premium?.vehicleAge}`
                    : '',
                  claimFreeYear: data?.viewProposalTW?.premium
                    ?.claimFreeYear
                    ? `${data?.viewProposalTW?.premium?.claimFreeYear}`
                    : '',
                  creditScore: data?.viewProposalTW?.creditScore
                    ?.creditScore
                    ? `${data?.viewProposalTW?.creditScore?.creditScore}`
                    : '',
                  //SA975
                  NCB: data?.viewProposalTW?.premium
                    ?.NCB
                    ? `${data?.viewProposalTW?.premium?.NCB}`
                    : '',
                  //EA975
                },
                customer: {
                  id: customer?.cust_number
                    ? `${customer?.cust_number}`
                    : '',
                  title: customer?.indv_detail?.title?.code
                    ? `${customer?.indv_detail?.title?.code}`
                    : '',
                  gender: customer?.indv_detail?.gender?.code
                    ? `${customer?.indv_detail?.gender?.code}`
                    : '',
                  firstName: customer?.indv_detail?.first_name
                    ? `${customer?.indv_detail?.first_name}`
                    : '',
                  middleName: customer?.indv_detail?.middle_name
                    ? `${customer?.indv_detail?.middle_name}`
                    : '',
                  lastName: customer?.indv_detail?.surname
                    ? `${customer?.indv_detail?.surname}`
                    : '',
                  fullName: customer?.indv_detail?.full_name
                    ? `${customer?.indv_detail?.full_name}`
                    : '',
                  proposerDOB: customer?.indv_detail?.date_of_birth
                    ? `${customer?.indv_detail?.date_of_birth}`
                    : '',
                  maritalStatus: customer?.indv_detail?.marital_status
                    ?.code
                    ? `${customer?.indv_detail?.marital_status?.code}`
                    : '',
                  occupation: customer?.indv_detail?.occupation?.code
                    ? `${customer?.indv_detail?.occupation?.code}`
                    : '',
                  nationality: customer?.indv_detail?.nationality
                    ?.code
                    ? `${customer?.indv_detail?.nationality?.code}`
                    : '',
                  idProofType: customer?.indv_detail?.id_proof_type
                    ?.code
                    ? `${customer?.indv_detail?.id_proof_type?.code}`
                    : '',
                  idProofNumber: customer?.indv_detail
                    ?.id_proof_number
                    ? `${customer?.indv_detail?.id_proof_number}`
                    : '',
                  panNumber: customer?.indv_detail?.pan_card_number
                        || customer?.org_detail?.pan_card_number 
                    ? `${customer?.indv_detail?.pan_card_number 
                      || customer?.org_detail?.pan_card_number}`
                    : '',
                  orgName: customer?.org_detail?.org_name
                    ? `${customer?.org_detail?.org_name}`
                    : '',
                  orgType: customer?.org_detail?.org_type?.code
                    ? `${customer?.org_detail?.org_type?.code}`
                    : '',
                  contactName: customer?.org_detail?.contact_name
                    ? `${customer?.org_detail?.contact_name}`
                    : '',
                  regNumber: customer?.org_detail?.reg_number
                    ? `${customer?.org_detail?.reg_number}`
                    : '',
                  tanNumber: customer?.org_detail?.tan_number
                    ? `${customer?.org_detail?.tan_number}`
                    : '',
                  gstNumber:
                    customer?.org_detail?.gst_number ||
                    customer?.indv_detail?.gst_number
                      ? `${
                          customer?.org_detail?.gst_number ||
                          customer?.indv_detail?.gst_number
                        }`
                      : '',
                  permAddressLine1: customer?.permanent_address
                    ?.address_line1
                    ? `${customer?.permanent_address?.address_line1}`
                    : '',
                  permAddressLine2: customer?.permanent_address
                    ?.address_line2
                    ? `${customer?.permanent_address?.address_line2}`
                    : '',
                  permAddressLine3: customer?.permanent_address
                    ?.address_line3
                    ? `${customer?.permanent_address?.address_line3}`
                    : '',
                  permLandmark: customer?.permanent_address?.land_mark
                    ? `${customer?.permanent_address?.land_mark}`
                    : '',
                  permPincode: customer?.permanent_address?.pin_code
                    ? `${customer?.permanent_address?.pin_code}`
                    : '',
                  permCityTownVillage: customer?.permanent_address
                    ?.city
                    ? `${customer?.permanent_address?.city}`
                    : '',
                  permDistrict: customer?.permanent_address?.district
                    ? `${customer?.permanent_address?.district}`
                    : '',
                  permState: customer?.permanent_address?.state
                    ? `${customer?.permanent_address?.state}`
                    : '',
                  permCommAddressYN: customer?.comm_equal_perm
                    ? true
                    : false,
                  commAddressLine1: customer?.communication_address
                    ?.address_line1
                    ? `${customer?.communication_address?.address_line1}`
                    : '',
                  commAddressLine2: customer?.communication_address
                    ?.address_line2
                    ? `${customer?.communication_address?.address_line2}`
                    : '',
                  commAddressLine3: customer?.communication_address
                    ?.address_line3
                    ? `${customer?.communication_address?.address_line3}`
                    : '',
                  commLandmark: customer?.communication_address
                    .land_mark
                    ? `${customer?.communication_address?.land_mark}`
                    : '',
                  commPincode: customer?.communication_address
                    ?.pin_code
                    ? `${customer?.communication_address?.pin_code}`
                    : '',
                  commCityTownVillage: customer?.communication_address
                    ?.city
                    ? `${customer?.communication_address?.city}`
                    : '',
                  commDistrict: customer?.communication_address
                    ?.district
                    ? `${customer?.communication_address?.district}`
                    : '',
                  commState: customer?.communication_address?.state
                    ? `${customer?.communication_address?.state}`
                    : '',
                  phoneNo: customer?.contact?.telephone
                    ? `${customer?.contact?.telephone}`
                    : '',
                  mobileNo:
                    customer?.contact?.mobile ||
                    customer?.org_detail?.contact_mob
                      ? `${
                          customer?.contact?.mobile ||
                          customer?.org_detail?.contact_mob
                        }`
                      : '',
                  emailID:
                    customer?.contact?.email ||
                    customer?.org_detail?.contact_email
                      ? `${
                          customer?.contact?.email ||
                          customer?.org_detail?.contact_email
                        }`
                      : '',
                  faxNo: customer?.contact?.fax_number
                    ? `${customer?.contact?.fax_number}`
                    : '',
                  altPhoneNo: customer?.contact?.alt_telephone
                    ? `${customer?.contact?.alt_telephone}`
                    : '',
                  altMobileNo: customer?.contact?.alt_mobile
                    ? `${customer?.contact?.alt_mobile}`
                    : '',
                  employeeNumber: customer?.indv_detail
                    ?.employeeNumber
                    ? `${customer?.indv_detail?.employeeNumber}`
                    : '',
                },
                customerMeta: {
                  crn: customer?.cust_ref_number
                    ? `${customer?.cust_ref_number}`
                    : '',
                  isNewCustomer: false,
                  ifscCode: customer?.bank_detail?.ifsc_code
                    ? `${customer?.bank_detail?.ifsc_code}`
                    : '',
                  bankName: customer?.bank_detail?.name
                    ? `${customer?.bank_detail?.name}`
                    : '',
                  branchName: customer?.bank_detail?.branch_name
                    ? `${customer?.bank_detail?.branch_name}`
                    : '',
                  bankAcno: customer?.bank_detail?.acc_number
                    ? `${customer?.bank_detail?.acc_number}`
                    : '',
                  accountHolderName: customer?.bank_detail?.acc_holder
                    ? `${customer?.bank_detail?.acc_holder}`
                    : '',
                  micrCode: customer?.bank_detail?.micr_code
                    ? `${customer?.bank_detail?.micr_code}`
                    : '',
                },
                isPremiumCalculating: null,
                policy:{
                  startDate: data?.viewProposalTW?.policy?.startDate,
                  expiryDate: data?.viewProposalTW?.policy?.endDate,
                },
              },
              coverData: {
                rawRiskData: applicableCovers?.riskCovers,
                addOnCovers,
              },
              quoteNumber: data?.viewProposalTW?.quoteNumber
                ? `${data?.viewProposalTW?.quoteNumber}`
                : '',
              quoteStatus: '',
              quoteCreationDate: '',
              proposalNumber: data?.viewProposalTW?.proposalNumber
                ? `${data?.viewProposalTW?.proposalNumber}`
                : '',
                                 //SA BT20641
              policyNumber:data?.viewProposalTW?.policyNumber
              ? `${data?.viewProposalTW?.policyNumber}`
              : '',
              //EA BT20641
              proposalStatus: data?.viewProposalTW?.proposalStatus
                ? `${data?.viewProposalTW?.proposalStatus}`
                : '',
              proposalPaymentType: (data?.viewProposalTW?.businessType === 'Renewal Business'
                || data?.viewProposalTW?.quoteNumber === 'NA'
                || data?.viewProposalTW?.quoteNumber === null
                ) ? 'EPROPOSAL' 
                : data?.viewProposalTW?.proposalPaymentType
                    ? `${data?.viewProposalTW?.proposalPaymentType}`
                    : '',
              isProposalApplicableForPayment: data?.viewProposalTW
                ?.isApplicableForPayment
                ? true
                : false,
              isPolicyIssued: false,
              existingPolicyNumber: '',
              isExistingEmployee: '',
              proposerDetailsMeta: {
                crn: customer?.cust_ref_number
                  ? `${customer?.cust_ref_number}`
                  : '',
                isNewCustomer: false,
                ifscCode: customer?.bank_detail?.ifsc_code
                  ? `${customer?.bank_detail?.ifsc_code}`
                  : '',
                bankName: customer?.bank_detail?.name
                  ? `${customer?.bank_detail?.name}`
                  : '',
                branchName: customer?.bank_detail?.branch_name
                  ? `${customer?.bank_detail?.branch_name}`
                  : '',
                bankAcno: customer?.bank_detail?.acc_number
                  ? `${customer?.bank_detail?.acc_number}`
                  : '',
                accountHolderName: customer?.bank_detail?.acc_holder
                  ? `${customer?.bank_detail?.acc_holder}`
                  : '',
                micrCode: customer?.bank_detail?.micr_code
                  ? `${customer?.bank_detail?.micr_code}`
                  : '',
              },
              proposerDetails: {
                id: customer?.cust_number
                  ? `${customer?.cust_number}`
                  : '',
                customerType: customer?.cust_type?.code
                  ? `${customer?.cust_type?.code}`
                  : '',
                isThinCustomer: false,
                title: customer?.indv_detail?.title?.code
                  ? `${customer?.indv_detail?.title?.code}`
                  : '',
                gender: customer?.indv_detail?.gender?.code
                  ? `${customer?.indv_detail?.gender?.code}`
                  : '',
                firstName: customer?.indv_detail?.first_name
                  ? `${customer?.indv_detail?.first_name}`
                  : '',
                middleName: customer?.indv_detail?.middle_name
                  ? `${customer?.indv_detail?.middle_name}`
                  : '',
                lastName: customer?.indv_detail?.surname
                  ? `${customer?.indv_detail?.surname}`
                  : '',
                fullName: customer?.indv_detail?.full_name
                  ? `${customer?.indv_detail?.full_name}`
                  : '',
                proposerDOB: customer?.indv_detail?.date_of_birth
                  ? `${customer?.indv_detail?.date_of_birth}`
                  : '',
                maritalStatus: customer?.indv_detail?.marital_status
                  ?.code
                  ? `${customer?.indv_detail?.marital_status?.code}`
                  : '',
                occupation: customer?.indv_detail?.occupation?.code
                  ? `${customer?.indv_detail?.occupation?.code}`
                  : '',
                nationality: customer?.indv_detail?.nationality?.code
                  ? `${customer?.indv_detail?.nationality?.code}`
                  : '',
                idProofType: customer?.indv_detail?.id_proof_type
                  ?.code
                  ? `${customer?.indv_detail?.id_proof_type?.code}`
                  : '',
                idProofNumber: customer?.indv_detail?.id_proof_number
                  ? `${customer?.indv_detail?.id_proof_number}`
                  : '',
                panNumber: customer?.indv_detail?.pan_card_number
                || customer?.org_detail?.pan_card_number
                  ? `${customer?.indv_detail?.pan_card_number
                  || customer?.org_detail?.pan_card_number}`
                  : '',
                orgName: customer?.org_detail?.org_name
                  ? `${customer?.org_detail?.org_name}`
                  : '',
                orgType: customer?.org_detail?.org_type?.code
                  ? `${customer?.org_detail?.org_type?.code}`
                  : '',
                contactName: customer?.org_detail?.contact_name
                  ? `${customer?.org_detail?.contact_name}`
                  : '',
                regNumber: customer?.org_detail?.reg_number
                  ? `${customer?.org_detail?.reg_number}`
                  : '',
                tanNumber: customer?.org_detail?.tan_number
                  ? `${customer?.org_detail?.tan_number}`
                  : '',
                gstNumber:
                  customer?.org_detail?.gst_number ||
                  customer?.indv_detail?.gst_number
                    ? `${
                        customer?.org_detail?.gst_number ||
                        customer?.indv_detail?.gst_number
                      }`
                    : '',
                permAddressLine1: customer?.permanent_address
                  ?.address_line1
                  ? `${customer?.permanent_address?.address_line1}`
                  : '',
                permAddressLine2: customer?.permanent_address
                  ?.address_line2
                  ? `${customer?.permanent_address?.address_line2}`
                  : '',
                permAddressLine3: customer?.permanent_address
                  ?.address_line3
                  ? `${customer?.permanent_address?.address_line3}`
                  : '',
                permLandmark: customer?.permanent_address?.land_mark
                  ? `${customer?.permanent_address?.land_mark}`
                  : '',
                permPincode: customer?.permanent_address?.pin_code
                  ? `${customer?.permanent_address?.pin_code}`
                  : '',
                permCityTownVillage: customer?.permanent_address?.city
                  ? `${customer?.permanent_address?.city}`
                  : '',
                permDistrict: customer?.permanent_address?.district
                  ? `${customer?.permanent_address?.district}`
                  : '',
                permState: customer?.permanent_address?.state
                  ? `${customer?.permanent_address?.state}`
                  : '',
                permCommAddressYN: customer?.comm_equal_perm
                  ? true
                  : false,
                commAddressLine1: customer?.communication_address
                  ?.address_line1
                  ? `${customer?.communication_address?.address_line1}`
                  : '',
                commAddressLine2: customer?.communication_address
                  ?.address_line2
                  ? `${customer?.communication_address?.address_line2}`
                  : '',
                commAddressLine3: customer?.communication_address
                  ?.address_line3
                  ? `${customer?.communication_address?.address_line3}`
                  : '',
                commLandmark: customer?.communication_address
                  .land_mark
                  ? `${customer?.communication_address?.land_mark}`
                  : '',
                commPincode: customer?.communication_address?.pin_code
                  ? `${customer?.communication_address?.pin_code}`
                  : '',
                commCityTownVillage: customer?.communication_address
                  ?.city
                  ? `${customer?.communication_address?.city}`
                  : '',
                commDistrict: customer?.communication_address
                  ?.district
                  ? `${customer?.communication_address?.district}`
                  : '',
                commState: customer?.communication_address?.state
                  ? `${customer?.communication_address?.state}`
                  : '',
                phoneNo: customer?.contact?.telephone
                  ? `${customer?.contact?.telephone}`
                  : '',
                mobileNo:
                  customer?.contact?.mobile ||
                  customer?.org_detail?.contact_mob
                    ? `${
                        customer?.contact?.mobile ||
                        customer?.org_detail?.contact_mob
                      }`
                    : '',
                emailID:
                  customer?.contact?.email ||
                  customer?.org_detail?.contact_email
                    ? `${
                        customer?.contact?.email ||
                        customer?.org_detail?.contact_email
                      }`
                    : '',
                faxNo: customer?.contact?.fax_number
                  ? `${customer?.contact?.fax_number}`
                  : '',
                altPhoneNo: customer?.contact?.alt_telephone
                  ? `${customer?.contact?.alt_telephone}`
                  : '',
                altMobileNo: customer?.contact?.alt_mobile
                  ? `${customer?.contact?.alt_mobile}`
                  : '',
                employeeNumber: customer?.indv_detail?.employeeNumber
                  ? `${customer?.indv_detail?.employeeNumber}`
                  : '',
              },
              vehicleTabDetails: {
                vehicleRegistrationDetails: {
                  registrationNumber: data?.viewProposalTW
                    ?.vehicleDetails?.registrationNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.registrationNumber}`
                    : '',
                  engineNumber: data?.viewProposalTW?.vehicleDetails
                    ?.engineNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.engineNumber}`
                    : '',
                  chasisNumber: data?.viewProposalTW?.vehicleDetails
                    ?.chasisNumber
                    ? `${data?.viewProposalTW?.vehicleDetails?.chasisNumber}`
                    : '',
                  preInspectionNumber:data?.viewProposalTW?.vehicleDetails?.preInspectionNumber
                  ?data?.viewProposalTW?.vehicleDetails?.preInspectionNumber
                  :'',
                  registrationNumberParts: {
                    part1:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            0,
                            2,
                          )
                        : '',
                    part2:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            2,
                            4,
                          )
                        : '',
                    part3:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            4,
                            6,
                          )
                        : '',
                    part4:
                      data?.viewProposalTW?.vehicleDetails
                        ?.registrationNumber &&
                      data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() !==
                        'new'
                        ? data?.viewProposalTW?.vehicleDetails?.registrationNumber?.slice(
                            6,
                          )
                        : '',
                  },
                  isNewVehicle:
                    data?.viewProposalTW?.vehicleDetails?.registrationNumber?.toLowerCase() ===
                    'new',
                },
                vehicleDetails: {
                  make: {
                    code: data?.viewProposalTW?.vehicleDetails?.make
                      ?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.make?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails?.make
                      ?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.make?.value}`
                      : '',
                  },
                  model: {
                    code: data?.viewProposalTW?.vehicleDetails?.model
                      ?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.model?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails?.model
                      ?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.model?.value}`
                      : '',
                  },
                  variant: {
                    code: data?.viewProposalTW?.vehicleDetails
                      ?.variant?.code
                      ? `${data?.viewProposalTW?.vehicleDetails?.variant?.code}`
                      : '',
                    value: data?.viewProposalTW?.vehicleDetails
                      ?.variant?.value
                      ? `${data?.viewProposalTW?.vehicleDetails?.variant?.value}`
                      : '',
                  },
                  fuelType: data?.viewProposalTW?.vehicleDetails
                    ?.fuelType
                    ? `${data?.viewProposalTW?.vehicleDetails?.fuelType}`
                    : '',
                  cubeCapacity: data?.viewProposalTW?.vehicleDetails
                    ?.cubicCapacity
                    ? `${data?.viewProposalTW?.vehicleDetails?.cubicCapacity}`
                    : '',
                  gvw: data?.viewProposalTW?.vehicleDetails?.gvw
                  ?data?.viewProposalTW?.vehicleDetails
                  ?.gvw
                  :'',  
                  seatingCapacity: data?.viewProposalTW
                    ?.vehicleDetails?.seatingCapacity
                    ? `${data?.viewProposalTW?.vehicleDetails?.seatingCapacity}`
                    : '',
                  yearOfManufacture: data?.viewProposalTW
                    ?.vehicleDetails?.manufactureYear
                    ? `${data?.viewProposalTW?.vehicleDetails?.manufactureYear}`
                    : '',
                  rtoDetails: {
                    rtoAuthorityCode: data?.viewProposalTW?.rtoDetails
                      ?.rtoAuthCode
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoAuthCode}`
                      : '',
                    rtoLocationCode: data?.viewProposalTW?.rtoDetails
                      ?.rtoLocCode
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoLocCode}`
                      : '',
                    rtoLocationDesc: data?.viewProposalTW?.rtoDetails
                      ?.rtoLocDesc
                      ? `${data?.viewProposalTW?.rtoDetails?.rtoLocDesc}`
                      : '',
                  },
                  dateOfRegistration: data?.viewProposalTW
                    ?.vehicleDetails?.regPurchaseDate
                    ? `${data?.viewProposalTW?.vehicleDetails?.regPurchaseDate}`
                    : '',
                },
                insuredDeclaredDetails: {
                  vehicleIDV: data?.viewProposalTW?.totalIDV
                    ? parseFloat(data?.viewProposalTW?.totalIDV)-parseFloat(data?.viewProposalTW?.bodyIDV)
                    : null,
                  irfAdjustmentPercent: data?.viewProposalTW?.irf1
                    ? `${data?.viewProposalTW?.irf1}`
                    : '',
                },
              },
              additionalTabDetails: {
                previousInsuranceAndClaims: {
                  previousPolicyDetails: {
                    previousInsurerName: data?.viewProposalTW
                      ?.prevInsuranceDetails?.insurerName
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.insurerName}`
                      : '',
                    expiringPolicyNumber: data?.viewProposalTW
                      ?.prevInsuranceDetails?.policyNumber
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyNumber}`
                      : '',
                    policyCoverType: data?.viewProposalTW
                      ?.prevInsuranceDetails?.coverType
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.coverType}`
                      : '',
                    policyStartDate: data?.viewProposalTW
                      ?.prevInsuranceDetails?.startDate
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.startDate}`
                      : '',
                    policyExpiryDate: data?.viewProposalTW
                      ?.prevInsuranceDetails?.expiryDate
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.expiryDate}`
                      : '',
                    policyTenure: data?.viewProposalTW
                      ?.prevInsuranceDetails?.policyTenure
                      ? `${data?.viewProposalTW?.prevInsuranceDetails?.policyTenure}`
                      : '',
                    policyTenureValue:
                      PRD_PreviousPolicyTermList &&
                      PRD_PreviousPolicyTermList?.length > 0
                        ? PRD_PreviousPolicyTermList?.find(
                            (policyTerm) =>
                              policyTerm?.code?.toLowerCase() ===
                              data?.viewProposalTW?.prevInsuranceDetails?.policyTenure?.toLowerCase(),
                          )?.value
                        : '',
                  },
                  previousClaims: {
                    totalClaimCount: data?.viewProposalTW
                      ?.previousClaims?.totalClaimCount
                      ? `${data?.viewProposalTW?.previousClaims?.totalClaimCount}`
                      : '',
                    totalClaimCountValue:
                      PRD_TotalClaimCountList &&
                      PRD_TotalClaimCountList?.length > 0
                        ? PRD_TotalClaimCountList?.find(
                            (totalClaimCount) =>
                              totalClaimCount?.code?.toLowerCase() ===
                              data?.viewProposalTW?.previousClaims?.totalClaimCount?.toLowerCase(),
                          )?.value
                        : '',
                    totalClaimAmount:
                      data?.viewProposalTW?.previousClaims
                        ?.totalClaimAmount !== null &&
                      data?.viewProposalTW?.previousClaims
                        ?.totalClaimAmount !== undefined
                        ? `${data?.viewProposalTW?.previousClaims?.totalClaimAmount}`
                        : '',
                    previousYearNCBSlab: data?.viewProposalTW
                      ?.previousClaims?.prevNCBSlab
                      ? `${data?.viewProposalTW?.previousClaims?.prevNCBSlab}`
                      : '',
                    noOfClaimsYear1: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear1
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear1}`
                      : '',
                    noOfClaimsYear2: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear2
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear2}`
                      : '',
                    noOfClaimsYear3: data?.viewProposalTW
                      ?.previousClaims?.claimsInYear3
                      ? `${data?.viewProposalTW?.previousClaims?.claimsInYear3}`
                      : '',
                  },
                },
                financeDetails: {
                  vehicleOwned:
                    data?.viewProposalTW?.financerDetails
                      ?.vehicleOwned &&
                    PRD_IsYourVehicle &&
                    PRD_IsYourVehicle?.length > 0
                      ? PRD_IsYourVehicle?.find(
                          (isYourVehicle) =>
                            isYourVehicle?.code
                              ?.toString()
                              ?.trim()
                              ?.toLowerCase() ===
                            data?.viewProposalTW?.financerDetails?.vehicleOwned
                              ?.toString()
                              ?.trim()
                              ?.toLowerCase(),
                        )
                        ? `${
                            PRD_IsYourVehicle?.find(
                              (isYourVehicle) =>
                                isYourVehicle?.code
                                  ?.toString()
                                  ?.trim()
                                  ?.toLowerCase() ===
                                data?.viewProposalTW?.financerDetails?.vehicleOwned
                                  ?.toString()
                                  ?.trim()
                                  ?.toLowerCase(),
                            )?.code
                          }`
                        : ''
                      : '',
                  financerDetails: {
                    financerName: data?.viewProposalTW
                      ?.financerDetails?.financerName
                      ? `${data?.viewProposalTW?.financerDetails?.financerName}`
                      : '',
                    financerAddress: data?.viewProposalTW
                      ?.financerDetails?.financerAddress
                      ? `${data?.viewProposalTW?.financerDetails?.financerAddress}`
                      : '',
                    financerAgreementType:
                      data?.viewProposalTW?.financerDetails
                        ?.financerAgreementType &&
                      PRD_FinancerAgreementType &&
                      PRD_FinancerAgreementType?.length > 0
                        ? PRD_FinancerAgreementType?.find(
                            (financerAgreementType) =>
                              financerAgreementType?.code
                                ?.toString()
                                ?.trim()
                                ?.toLowerCase() ===
                              data?.viewProposalTW?.financerDetails?.financerAgreementType
                                ?.toString()
                                ?.trim()
                                ?.toLowerCase(),
                          )
                          ? `${
                              PRD_FinancerAgreementType?.find(
                                (financerAgreementType) =>
                                  financerAgreementType?.code
                                    ?.toString()
                                    ?.trim()
                                    ?.toLowerCase() ===
                                  data?.viewProposalTW?.financerDetails?.financerAgreementType
                                    ?.toString()
                                    ?.trim()
                                    ?.toLowerCase(),
                              )?.code
                            }`
                          : ''
                        : '',
                    loanAccountNumber: data?.viewProposalTW
                      ?.financerDetails?.loanAccountNumber
                      ? `${data?.viewProposalTW?.financerDetails?.loanAccountNumber}`
                      : '',
                    fileNumber: data?.viewProposalTW?.financerDetails
                      ?.fileNumber
                      ? `${data?.viewProposalTW?.financerDetails?.fileNumber}`
                      : '',
                  },
                },
              },
              reviewAndConfirmTabDetails: {
                leadGenerator: data?.viewProposalTW?.leadGenerator
                  ? `${data?.viewProposalTW?.leadGenerator}`
                  : '',
                isProposalCreated: true,
                proposalPaymentType: (data?.viewProposalTW?.businessType === 'Renewal Business'
                    || data?.viewProposalTW?.quoteNumber === 'NA'
                    || data?.viewProposalTW?.quoteNumber === null
                  ) ? 'EPROPOSAL' 
                  : data?.viewProposalTW?.proposalPaymentType
                    ? `${data?.viewProposalTW?.proposalPaymentType}`
                    : '',
              },
              policy: {
                startDate: data?.viewProposalTW?.policy?.startDate
                  ? `${data?.viewProposalTW?.policy?.startDate}`
                  : '',
                endDate: data?.viewProposalTW?.policy?.endDate
                  ? `${data?.viewProposalTW?.policy?.endDate}`
                  : '',
                time: data?.viewProposalTW?.policy?.time
                  ? `${data?.viewProposalTW?.policy?.time}`
                  : '',
              },
              issuedPolicyData: {
                policyNo: '',
                receiptID: [],
                referenceNumber: '',
                digiLink: '',
                displayMessage: '',
                additionalMessage: '',
              },
              premiumData: {
                idv1: data?.viewProposalTW?.premium?.idv1
                  ? `${data?.viewProposalTW?.premium?.idv1}`
                  : '',
                idv2: data?.viewProposalTW?.premium?.idv2
                  ? `${data?.viewProposalTW?.premium?.idv2}`
                  : '',
                idv3: data?.viewProposalTW?.premium?.idv3
                  ? `${data?.viewProposalTW?.premium?.idv3}`
                  : '',
                tenure: data?.viewProposalTW?.premium?.tenure
                  ? `${data?.viewProposalTW?.premium?.tenure}`
                  : '',
                netODPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netODPremium,
                ),
                netTPPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netTPPremium,
                ),
                loadingDiscount: parseFloat(
                  data?.viewProposalTW?.premium?.loadingDiscount,
                ),
                netPremium: parseFloat(
                  data?.viewProposalTW?.premium?.netPremium,
                ),
                gst: parseFloat(data?.viewProposalTW?.premium?.gst),
                stampDuty: parseFloat(
                  data?.viewProposalTW?.premium?.stampDuty,
                ),
                totalPremium: parseFloat(
                  data?.viewProposalTW?.premium?.totalPremium,
                ),
                loading:
                  data?.viewProposalTW?.premium?.loading &&
                  data?.viewProposalTW?.premium?.loading?.length > 0
                    ? data?.viewProposalTW?.premium?.loading
                    : [],
                discount:
                  data?.viewProposalTW?.premium?.discount &&
                  data?.viewProposalTW?.premium?.discount?.length > 0
                    ? data?.viewProposalTW?.premium?.discount
                    : [],
                vehicleAge: data?.viewProposalTW?.premium?.vehicleAge
                  ? `${data?.viewProposalTW?.premium?.vehicleAge}`
                  : '',
                claimFreeYear: data?.viewProposalTW?.premium
                  ?.claimFreeYear
                  ? `${data?.viewProposalTW?.premium?.claimFreeYear}`
                  : '',
                creditScore: data?.viewProposalTW?.creditScore
                  ?.creditScore
                  ? `${data?.viewProposalTW?.creditScore?.creditScore}`
                  : '',
		  //SA975
                  NCB: data?.viewProposalTW?.premium
                  ?.NCB
                  ? `${data?.viewProposalTW?.premium?.NCB}`
                  : '',
                  //EA975
              },
              premiumDetails: {
                termsAndConditions: false,
                paymentMethod: '',
                payerType: '',
                onlinePayment: {
                  transactionId: '',
                  isTransactionIdVerified: null,
                },
                cdWallet: {
                  cdAccountNo: '',
                  cdAccountBalance: '',
                },
                cheque: [],
                demandDraft: [],
              },
              preinspectionDetails: {
                isVehicleInspectionNeeded: data?.viewProposalTW
                ?.isVehicleInspectionNeeded
                ? true
                : false,
              }
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchViewProposalData();
  }, [data, dataCustomerDetails, dataMyIntermediaries]);

  return loading ||
    loadingCustomerDetails ||
    loadingMyIntermediaries ? (
    <Loading />
  ) : error || errorCustomerDetails || errorMyIntermediaries ? (
    <Error
      error={error || errorCustomerDetails || errorMyIntermediaries}
    />
  ) : customerID?.toString()?.toLowerCase() ===
      data?.viewProposalTW?.customerID?.toString()?.toLowerCase() &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewProposalTW?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <NewMotorPolicyIssuance
      startStep={3}
      isProposalNumberGenerated={true}
      customerID={customerID}
      lobCode={lobCode}
      lobName={lobName}
      productName={productName}
      productCode={productCode}
      proposalNumber={proposalNumber}
      stepsDisabled={[true, true, true, false, false]}
      breadcrumbNav={['Quote', 'View Proposal', 'Buy Policy']}
    />
  ) : customerID?.toString()?.toLowerCase() !==
    data?.viewProposalTW?.customerID?.toString()?.toLowerCase() ? (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Incorrect Customer ID for the given Proposal Number.
        </Text>
      </Card>
    </Layout>
  ) : (
    <Layout
      nav={['Quote', 'View Proposal', 'Buy Policy']}
      service_type={ClientService}
      title={`Your ${productName} Proposal`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view proposal belonging
          to another intermediary.
        </Text>
      </Card>
    </Layout>
  );
}
